var setup = false;

export const loaded = new Promise((resolve, reject) => {
    window["initMap"] = resolve
})

export const load = () => {
    if (setup) return;

    let script = document.createElement('SCRIPT')
    script.async = true
    script.defer = true
    script.src = 'https://cdn.jsdelivr.net/npm/ol@v8.2.0/dist/ol.js'
    script.addEventListener('load', (event) => {
        initMap()
    })

    document.body.appendChild(script)
    setup = true
}



// WEBPACK FOOTER //
// ./src/loader.js